// extracted by mini-css-extract-plugin
module.exports = {"cell":"Requirements_cell__1CQ_v","rightAlign":"Requirements_rightAlign__CB8TY","outLinkIcon":"Requirements_outLinkIcon__K3NnU"};